import React, { useRef, useState } from "react";
import Grain from "../Grain/Grain";
import Reveal from "../Reveal/Reveal";
import { FAQ } from "../../data/siteContent";
import "./styles.css";

const FaqItem = ({ id, question, answer, open, onToggle }) => {
  const answerRef = useRef(null);

  return (
    <div className={`faq-item ${open ? "open" : ""}`}>
      <button
        type="button"
        className="faq-q"
        aria-expanded={open}
        aria-controls={id}
        onClick={onToggle}
      >
        <span className="box">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5">
            <path d="M20 6 9 17l-5-5" />
          </svg>
        </span>
        {question}
        <svg className="chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="m6 9 6 6 6-6" />
        </svg>
      </button>
      <div
        id={id}
        className="faq-a"
        ref={answerRef}
        style={{ maxHeight: open ? answerRef.current?.scrollHeight : 0 }}
      >
        <p>{answer}</p>
      </div>
    </div>
  );
};

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="faq dossie" id="faq">
      <div className="margin-line right" />
      <Grain variant="paper" />
      <div className="container">
        <Reveal className="section-head">
          <span className="tag" style={{ color: "var(--blue-2)" }}>
            Dossiê de dúvidas
          </span>
          <h2 className="display">Antes de assinar, confira</h2>
        </Reveal>
        <Reveal className="faq-list">
          {FAQ.map((item, i) => (
            <FaqItem
              key={item.question}
              id={`faq-${i}`}
              {...item}
              open={openIndex === i}
              onToggle={() => setOpenIndex(openIndex === i ? null : i)}
            />
          ))}
        </Reveal>
      </div>
    </section>
  );
};

export default Faq;
